import { render, staticRenderFns } from "./LogBox.vue?vue&type=template&id=3489feae&scoped=true"
import script from "./LogBox.vue?vue&type=script&lang=js"
export * from "./LogBox.vue?vue&type=script&lang=js"
import style0 from "./LogBox.vue?vue&type=style&index=0&id=3489feae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3489feae",
  null
  
)

export default component.exports